<template>
  <div class="card course-card">
    <div class="card-title">
      <div class="card-title__wrapper">
        <span>我的课程</span>
        <img
          class="planet"
          src="https://vanthink.oss-cn-qingdao.aliyuncs.com/0f7d8ff02bcb1dbb81a29c6d881bf798.png" alt="">
      </div>
    </div>
    <div class="card-content-wrapper">
      <div class="card-content__title">近期学习</div>
      <div class="card-content__info">
        <div class="card-content__left">
          <template v-if="!couruseInfo.length">
            <img
              class="default-image"
              src="https://vanthink.oss-cn-qingdao.aliyuncs.com/a83e4c840eb912774729a0569b7bdbc2.png"
              alt="">
          </template>
          <template v-else>
            <div
              class="item"
              :class="{ active: currentCourseId === course.id }"
              v-for="(course, index) in couruseInfo"
              @click="openCourseDetail(course)"
              :key="index">
              <div class="icon">{{formatCourseShortName(course)}}</div>
              <div class="course-name">{{course.name}}</div>
              <el-progress
                class="prpgress"
                :width="70"
                type="circle"
                :percentage="course.completion_rate"
                :color="currentCourseId ? '#62d8e8' : '#3f94db'"
              ></el-progress>
            </div>
          </template>
          <div
            class="filler-wrapper"
            v-if="couruseInfo.length && couruseInfo.length <= 2">
            <img src="https://vanthink.oss-cn-qingdao.aliyuncs.com/508fa7de7e61bac0175bbf551bf320af.png" alt="">
            <div class="filler">近期暂无其他学习课程</div>
          </div>
        </div>
        <div class="card-content__right">
          <div
            class="top feature-btn"
            @click="selectCourse">
              <div class="first">
                <span class="name">选择学科</span>
                <button class="btn btn-primary btn-circle">GO!</button>
              </div>
              <div class="last">前往宇宙图书馆挑选你的专属课程，展开全新的知识领域。</div>
            </div>
          <div class="bottom feature-btn">
            <div class="first">
              <span class="name">自主复习</span>
              <button @click="start('reviewCourse')" class="btn btn-primary btn-circle">GO!</button>
            </div>
            <div class="last">前往复习训练室，巩固已学过的课程，强化自身学习能力。</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Progress } from 'element-ui';
import utils from '@/services/utils';
import courseApi from '@/api/course';

export default {
  components: {
    ElProgress: Progress,
  },
  props: {
    couruseInfo: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      currentCourseId: 0,
    };
  },
  methods: {
    selectCourse() {
      this.$emit('change', {
        scene: 'selectCourse',
      });
    },
    noStart() {
      utils.message('敬请期待！');
    },
    start(scene) {
      if (scene === 'reviewCourse') {
        courseApi.verifyCourseListIsExist({
          type: 'active',
        })
          .then(() => {
            this.$emit('change', {
              scene,
            });
          });
        return;
      }
      this.$emit('change', {
        scene,
      });
    },
    openCourseDetail(course) {
      const playCodeToBookTypeMapping = {
        DiShengHuiKao: 'DS',
        English: 'BKW',
        EnglishWord: 'BDC',
        Chinese: 'YW',
      };
      let scene;
      let type;

      this.currentCourseId = course.id;
      if (course.is_expired) {
        utils.error('课程已过期');
        return;
      }
      if (course.code === 'EnglishWord') {
        scene = 'wordUnit';
        course.type = 'BDC';
        type = 'bdc_learn';
      } else if (course.code === 'DiShengHuiKao') {
        scene = 'dsUnit';
      } else {
        scene = 'unitModule';
      }
      this.$emit('change', {
        scene,
        params: {
          course: {
            ...course,
            type: playCodeToBookTypeMapping[course.code],
            projectCode: course.project_code,
          },
          type,
        },
      });
    },
    formatCourseShortName(course) {
      /* eslint-disable */
      if (course.project_code === 'English') {
        return 'En';
      } else if (course.project_code === 'Chinese') {
        return '语';
      } else if (course.project_code === 'Chemistry') {
        return '化';
      } else if (course.project_code === 'DiShengHuiKao' && course.subject_group === 'DL') {
        return '地';
      } else if (course.project_code === 'DiShengHuiKao' && course.subject_group === 'LS') {
        return '历';
      } else if (course.project_code === 'DiShengHuiKao' && course.subject_group === 'SDSHK') {
        return '会';
      } else if (course.project_code === 'DiShengHuiKao' && course.subject_group === 'SW') {
        return '生';
      }
      return '';
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/variables.scss";
@import "@/styles/common/breadcrumb.scss";
.course-card {
  margin: 9vh auto 0;
  width: min-content;
  .card-title {
    background: #0BC679;
  }
  .card-content-wrapper {
    padding: 0 20px;
    overflow: hidden;
    .card-content__title {
      margin: 15px 0;
      color: #224c64;
      font-size: 2vh;
      font-weight: 700;
    }
    .card-content__info {
      margin-bottom: 20px;
      display: flex;
      justify-content: space-between;
      .card-content__left {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        min-width: 470px;
        min-height: 260px;
        .default-image {
          width: 34vw;
          border-radius: 10px;
        }
        .item {
          box-sizing: border-box;
          display: flex;
          align-items: center;
          margin: 1.6vh 0;
          padding: 0 20px;
          height: 10vh;
          min-height: 80px;
          background: #edebfb;
          border-radius: 24px;
          &:hover {
            cursor: pointer;
            background: $primary;
            .icon {
              color: $primary;
              background: url("https://vanthink.oss-cn-qingdao.aliyuncs.com/4690948a5ca11ea50c5a509a33059c54.png")
                no-repeat 100% 100%;
              background-size: cover;
            }
            .course-name {
              color: #fff;
            }
            .prpgress {
              /deep/ .el-progress__text {
                color: #fff;
              }
            }
          }
          .icon {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 77px;
            height: 60px;
            color: #fff;
            font-size: 1.85vh;
            font-weight: 700;
            background: url("https://vanthink.oss-cn-qingdao.aliyuncs.com/4a359cd1b0539cc17c90a8c9212f2a4f.png")
              no-repeat 100% 100%;
          }
          .course-name {
            margin-left: 20px;
            width: 240px;
            font-size: 2.2vh;
            font-weight: bold;
            color: #224c64;
            line-height: 1.5;
          }
          .prpgress {
            margin-left: 20px;
            /deep/ .el-progress__text {
              font-size: 1.66vh !important;
              color: #333;
              font-weight: 700;
            }
          }
          &.active {
            color: #fff;
            background: $primary;
            .icon {
              color: $primary;
              background-image: url('https://vanthink.oss-cn-qingdao.aliyuncs.com/15279c63475c0e6fc261755f99fcf8c8.png');
            }
            .course-name {
              color: #fff;
            }
            .prpgress {
              margin-left: 20px;
              /deep/ .el-progress__text {
                color: #fff;
              }
            }
          }
        }
        .filler-wrapper {
          flex: 1;
          display: flex;
          flex-direction: column;
          img {
            margin: 0 auto;
            width: 95%;
            margin-bottom: 1.6vh;
          }
          .filler {
            flex: 1;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 2.2vh;
            font-weight: bold;
            color: #224c64;
            line-height: 1.5;
            background: #edebfb;
            border-radius: 24px;
          }
        }
      }
      .card-content__right {
        margin-left: 20px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .feature-btn {
          margin: 10px 0;
          box-sizing: border-box;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          padding: 20px;
          width: 20.7vw;
          height: 9vw;
          color: #fff;
          cursor: pointer;
          border-radius: 18px;
          &:hover {
            filter: brightness(115%);
          }
          .first {
            display: flex;
            justify-content: space-between;
            align-items: center;
            width: 100%;
            .name {
              font-size: 3.7vh;
              font-weight: 700;
              color: #FFFFFF;
            }
            .btn {
              width: 72px;
              height: 32px;
              font-weight: 700;
            }
          }
          .last {
            margin-top: 10px;
            font-size: 1.48vh;
            line-height: 1.5;
            color: #FFFFFF;
          }
        }
        .top {
          background: url("https://vanthink.oss-cn-qingdao.aliyuncs.com/db3bf9ddb302fac9c4d85492eae1593b.png")
            no-repeat center center / cover;
        }
        .bottom {
          background: url('https://vanthink.oss-cn-qingdao.aliyuncs.com/92058248b66b04e4c6f0c819ca7a9f34.png')
            no-repeat center center / cover;
        }
      }
    }
  }
}
</style>
